import Router from '@triotech/vue-core/src/plugins/router';
import Store from '@triotech/vue-core/src/plugins/store';
import _ from '@triotech/vue-core/src/plugins/_';
import Config from '@triotech/vue-core/src/plugins/config';
import Moment from '@triotech/vue-core/src/vendor/moment';
import QS from '@triotech/vue-core/src/vendor/qs';
import I18n from '@triotech/vue-core/src/plugins/i18n';
import Ajax from './ajax';
import Helper from './helper';
import Demo from './demo';

Router.push = Router.replace;
window.Store = Store;

const parametersIsInvalid = (to) => {
  if (to.name === 'login') {
    Store.commit('set', { oauth: {} });
  }

  const { parameters } = Store.state;
  return _.isNil(parameters) || !(parameters.expire && parameters.expire > Number(Moment()));
};

Router.beforeResolve((to, from, next) => {
  let promises = [];

  if (parametersIsInvalid(to)) {
    promises.push(Ajax.publicRequest(`public/metadata/${Config.get('oauth.api_client_name')}`).then((data) => {
      const { parameters, image } = data;
      Store.commit('set', {
        parameters: {
          company: _.find(parameters, { label: 'company' }),
          monpcie: _.find(parameters, { label: 'front.uri', sub_value: 'ROLE_CANDIDATE' }),
          logo: image && image.upload_file_path,
          expire: Number(Moment().add(1, 'h')),
        },
      });
    }));
  }

  if (_.isNull(from.name)) {
    promises = promises.concat(Helper.getEnums());
  }

  Promise.all(promises).finally(() => {
    if (_.isNull(from.name)) {
      const qs = QS.parse(window.location.search.substring(1));
      if (qs.player) {
        Store.commit('set', { player: qs.player });
      }
      if (!Store.state.player && to.name !== 'error') {
        return next({ name: 'error', params: { code: '0001' } });
      }
      if (Helper.isPlayerDemo12) {
        Demo.setup();
      }
      if (Helper.isPlayerDemo12 || Helper.isPlayerDemo36) {
        document.title = I18n.t('meta.title_demo');
      }
    }
    return next();
  });
});
